import React, { useState, useEffect } from 'react';
import grammarData from './Data/findGrammar.json';
import SEO, { SITE_NAME } from '../../Components/SEO';
import './findGrammar.css'; // Importing the CSS file

const FindGrammar = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const currentExercise = grammarData[currentIndex];
  const words = currentExercise.text.split(' ');

  useEffect(() => {
    setSelectedIndices([]);
    setShowResults(false);
  }, [currentIndex]);

  const toggleWord = (index) => {
    if (showResults) return;
    setSelectedIndices(prev => 
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  // Helper to determine CSS classes dynamically
  const getWordClass = (index) => {
    const isSelected = selectedIndices.includes(index);
    const isTarget = currentExercise.targets.includes(index);
    let classes = 'word-token';

    if (showResults) {
      classes += ' disabled';
      if (isSelected && isTarget) return classes + ' correct';
      if (isSelected && !isTarget) return classes + ' wrong';
      if (!isSelected && isTarget) return classes + ' missed';
      return classes;
    }

    if (isSelected) classes += ' selected';
    return classes;
  };

   return (
    <div className="grammar-container">
      <SEO
        title="Free English Grammar in Context Exercises"
        description="Free English grammar exercises where you identify the correct words in a sentence. Practise real-world grammar with instant feedback."
        name={SITE_NAME}
        type="article"
      />
      <nav className="grammar-nav">
        <button onClick={() => setCurrentIndex(i => i - 1)} disabled={currentIndex === 0}>
          Previous
        </button>
        <span>TASK {currentIndex + 1} OF {grammarData.length}</span>
        <button onClick={() => setCurrentIndex(i => i + 1)} disabled={currentIndex === grammarData.length - 1}>
          Next
        </button>
      </nav>

      <main className="grammar-box">
        <h3>{currentExercise.task}</h3>
        <div className="grammar-text">
          {words.map((word, index) => (
            <span
              key={index}
              onClick={() => toggleWord(index)}
              className={getWordClass(index)}
            >
              {word}
            </span>
          ))}
        </div>
      </main>

      <footer className="footer-actions">
        {!showResults ? (
          <button className="check-btn" onClick={() => setShowResults(true)}>
            Check Answers
          </button>
        ) : (
          <div className="feedback-box">
            <p><strong>Explanation:</strong> {currentExercise.explanation}</p>
            <button className="try-again-btn" onClick={() => setShowResults(false)}>
              Reset Exercise
            </button>
          </div>
        )}
      </footer>
    </div>
  );
};

export default FindGrammar;
